import { FormLabel } from '@/components/ui/form'
import { DetailButtons } from './DetailButtons'
import RutsTable from './RutsTable'
import { rutsAKey, rutsBKey } from './constants'
import CreateModal from './CreateModal'

export function InterestConflictDetail({
  processData,
  setProcessData,
  handleGetTemplate,
  enrichmentType,
  isViewMode,
}: {
  processData: FormProcessData
  setProcessData: React.Dispatch<React.SetStateAction<FormProcessData>>
  handleGetTemplate: () => void
  enrichmentType: number | undefined
  isViewMode: boolean
}) {
  return (
    <>
      <div className="flex flex-row items-center w-full">
        <div className="form-title-label pb-5 pt-5 min-w-[150px]">Carga de archivos</div>
        <div className="flex justify-start items-center w-full">
          <CreateModal
            processData={processData}
            enrichmentType={enrichmentType}
            setProcessData={setProcessData}
            handleGetTemplate={handleGetTemplate}
            isViewMode={isViewMode}
          />
        </div>
      </div>
      <div className="flex flex-row space-x-8">
        <div className="flex flex-row items-center w-full">
          <FormLabel className="form-label w-full">Lista A - Colaboradores</FormLabel>
          <div className="flex justify-end items-center w-full">
            <DetailButtons
              processData={processData}
              setProcessData={setProcessData}
              enrichmentType={enrichmentType}
              rutKey={rutsAKey}
              isViewMode={isViewMode}
            />
          </div>
        </div>
        <div className="flex flex-row items-center w-full">
          <FormLabel className="form-label w-full">Lista B - Proveedores</FormLabel>
          <div className="flex justify-end items-center w-full">
            <DetailButtons
              processData={processData}
              setProcessData={setProcessData}
              enrichmentType={enrichmentType}
              rutKey={rutsBKey}
              isViewMode={isViewMode}
            />
          </div>
        </div>
      </div>
      <div className="flex flex-row space-x-8">
        <div className="flex-grow flex w-full">
          <RutsTable
            processData={processData}
            setProcessData={setProcessData}
            rutKey={rutsAKey}
            isViewMode={isViewMode}
          />
        </div>
        <div className="flex-grow flex w-full">
          <RutsTable
            processData={processData}
            setProcessData={setProcessData}
            rutKey={rutsBKey}
            isViewMode={isViewMode}
          />
        </div>
      </div>
    </>
  )
}
